import { Button, Skeleton, CheckList, Price, LazyImage, ImageContainer, Badge } from '@intigral/shared';
import { List } from '@intigral/shared/components/CheckList';
import styles from './tier.module.sass';
import cn from 'classnames';
import { PriceProps } from '@intigral/shared/components/Price';
// import { getParam } from '@intigral/utils';

interface TierProps extends React.HTMLAttributes<HTMLDivElement> {
    picture?: string | React.ReactNode;
    title?: string;
    info?: string | string[];
    channelLogos?: string[] | React.ReactNode[];
    channelCount?: number;
    price?: PriceProps;
    list: List[];
    features?: React.ReactElement;
    linkComponent?: React.ElementType;
    buttonText?: string;
    href?: string;
    label?: string;
    free?: boolean;
    isLoading?: boolean;
    showCtaBtn?: boolean;
    isCtaDisbled?: boolean;
    // handleButtonClick?: () => void;
    isPromoCodeAvailable?: boolean;
    ctaButton?: React.ReactNode;
    theme?: 'black';
}

export const Tier = ({
    picture,
    title,
    info,
    channelLogos,
    channelCount,
    price,
    list,
    features,
    buttonText,
    linkComponent: linkComponent,
    href,
    label,
    free,
    isLoading,
    className,
    showCtaBtn = true,
    isCtaDisbled = false,
    isPromoCodeAvailable = false,
    ctaButton,
    // handleButtonClick,
    theme,
    ...props
}: TierProps) => {
    const classes = cn(styles.tier, theme && styles[theme], className);

    if (isLoading) {
        return (
            <div className={classes} {...props}>
                <div className={styles.header}>
                    <div style={{ margin: '0 auto' }}>
                        <Skeleton variant="circle" width={72} height={72} />
                    </div>
                </div>
                <Skeleton variant="text" />
                <Skeleton variant="text" />
                <Skeleton variant="text" />
                <Skeleton variant="text" />
                <div style={{ margin: '0 auto' }}>
                    <Skeleton variant="rounded" width={156} height={36} />
                </div>
            </div>
        );
    }

    return (
        <div
            className={classes}
            style={{
                opacity: free && isPromoCodeAvailable ? 0.3 : 1,
                pointerEvents: free && isPromoCodeAvailable ? 'none' : 'auto',
            }}
            {...props}
        >
            {label && (
                <div className={styles.label} data-test-id="tier-label">
                    {label}
                </div>
            )}
            {picture && (
                <div className={styles.picture}>
                    {typeof picture == 'string' ? (
                        <LazyImage src={picture} data-test-id="tier-banner-image" />
                    ) : (
                        picture
                    )}
                </div>
            )}
            {info && (
                <div className={styles.description} data-test-id="tier-info-holder">
                    {Array.isArray(info) ? (
                        info.map((item, index) => <span key={index}>{item}</span>)
                    ) : (
                        <span>{info}</span>
                    )}
                </div>
            )}
            <div className={styles.header}>
                <strong className={styles.title} data-test-id="tier-title">
                    {title}
                </strong>
                {price && <Price {...price} className={styles.price} data-test-id="tier-price" />}
            </div>
            <CheckList items={list} className={styles.list} data-test-id="tier-description-list-holder" />
            {channelLogos && (
                <div className={styles.channels} data-test-id="tier-channel-list-holder">
                    {Array.isArray(channelLogos) ? (
                        channelLogos.map((item, index) =>
                            typeof item == 'string' ? (
                                <div key={item}>
                                    <ImageContainer src={item} ratio={1.5} alignment="start" />
                                </div>
                            ) : (
                                <div key={index}>{item}</div>
                            )
                        )
                    ) : typeof channelLogos == 'string' ? (
                        <div>
                            <ImageContainer src={channelLogos} ratio={1.5} alignment="start" />
                        </div>
                    ) : (
                        channelLogos
                    )}
                    {channelCount && <span className={styles.count}>+{channelCount}</span>}
                </div>
            )}
            {ctaButton}
            {features && <div className={styles.features}>{features}</div>}
        </div>
    );
};
